var _rect, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnCommentBest = function SvgIcnCommentBest(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 22,
    viewBox: "0 0 42 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 22,
    rx: 3,
    fill: "#753BBD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.032 14.496H11.732C13.544 14.496 14.456 13.56 14.456 12.228C14.456 11.004 13.736 10.44 12.752 10.284V10.224C13.7 9.948 14.096 9.312 14.096 8.472C14.096 7.188 13.352 6.444 11.492 6.444H9.032V14.496ZM9.98 13.704V10.716H11.576C12.776 10.716 13.448 11.124 13.448 12.168C13.448 13.2 12.836 13.704 11.672 13.704H9.98ZM9.98 9.96V7.248H11.42C12.548 7.248 13.124 7.572 13.124 8.58C13.124 9.624 12.368 9.96 11.36 9.96H9.98ZM15.7752 14.496H20.5873V13.692H16.7232V10.752H19.6753V9.948H16.7232V7.248H20.5512V6.444H15.7752V14.496ZM23.7889 14.64C25.6729 14.64 26.4889 13.704 26.4889 12.3C26.4889 10.944 25.7329 10.44 24.5449 10.032L23.7529 9.78C22.8409 9.468 22.5529 9.132 22.5529 8.364C22.5529 7.596 23.1049 7.116 24.0889 7.116C24.9769 7.116 25.6129 7.344 26.0809 7.56V6.756C25.6369 6.54 25.0729 6.312 24.1249 6.312C22.4449 6.312 21.6169 7.2 21.6169 8.448C21.6169 9.672 22.2529 10.248 23.3809 10.62L24.1609 10.896C25.1329 11.208 25.5289 11.544 25.5289 12.372C25.5289 13.248 24.9889 13.824 23.7529 13.824C22.9009 13.824 22.1089 13.608 21.4969 13.296V14.1C22.0369 14.4 22.8049 14.64 23.7889 14.64ZM29.5718 14.496H30.5078V7.248H32.9678V6.444H27.1118V7.248H29.5718V14.496Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnCommentBest, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_comment_best.a092d130.svg";
export { ForwardRef as ReactComponent };